import { type GalleryItemAttrs, toGalleryItem } from "@ext/markdown/elements/gallery/logic/getGalleryItemRatio";
import { type GalleryView, resolveGalleryView } from "@ext/markdown/elements/gallery/model/gallery";
import GalleryFrame from "@ext/markdown/elements/gallery/render/components/GalleryFrame";
import GalleryTitle from "@ext/markdown/elements/gallery/render/components/GalleryTitle";
import getGalleryItemsClassName from "@ext/markdown/elements/gallery/render/components/galleryItemsClassName";
import { Children, isValidElement, type ReactNode } from "react";

interface GalleryProps {
	view: GalleryView;
	title?: string;
	scale?: string;
	isPrint?: boolean;
	children?: ReactNode;
}

const Gallery = ({ view, title, scale, isPrint, children }: GalleryProps) => {
	const elements = Children.toArray(children).filter(isValidElement);
	const items = elements.map((element) => toGalleryItem(element.props as GalleryItemAttrs));

	return (
		<GalleryFrame
			caption={title && <GalleryTitle>{title}</GalleryTitle>}
			isPrint={isPrint}
			items={items}
			scale={scale}
			view={view}
		>
			<div className={getGalleryItemsClassName(resolveGalleryView(view, isPrint))} data-gallery-items>
				<div data-gallery-cells>{elements}</div>
			</div>
		</GalleryFrame>
	);
};

export default Gallery;
